import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import { Users } from 'lucide-react';
import React, { useContext, useState } from 'react';
import { AutomationEditorContext } from '../AutomationEditorContext';
import { Step } from '../Step';
import { useSegmentDefinitions } from '../useSegmentDefinitions';
import { CheckAudienceDialog } from './CheckAudienceDialog';

interface CheckAudienceStepProps {
  index: number;
}

export const CheckAudienceStep: React.FC<CheckAudienceStepProps> = ({ index }) => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { state } = editor;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { data: segmentDefinitions } = useSegmentDefinitions();

  const action = state.localContents.actionData?.[index];
  const isCorrectAction = action?.type === BusinessAutomationActionTypeEnum.CHECK_SEGMENT_MEMBERSHIP;
  if (!isCorrectAction) return null;

  const selectedSegmentId = action.segmentIds?.[0];
  const selectedSegment = segmentDefinitions?.find(s => s.canonicalVersionId === selectedSegmentId);
  const segmentName = selectedSegment?.name || null;
  const hasSegment = !!segmentName;

  const subtitle = hasSegment
    ? `Stop campaign for customers not in ${segmentName}`
    : 'Click Configure to select a segment';

  return (
    <>
      <Step
        index={index}
        icon={Users}
        title="Check Audience"
        subtitle={subtitle}
        needsSetup={!hasSegment}
        onConfigure={() => setIsDialogOpen(true)}
      />
      <CheckAudienceDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        action={action}
        index={index}
      />
    </>
  );
};
